import { SABox, SAText } from '@saux/design-system-react'
import styled from 'styled-components';
import { simpleGTMDataLayer } from '../../utils/utilities';
import { useSelector } from 'react-redux';
import Alerts_icon from '../../icons/Alerts.png';

const Template = styled.div`
    height: 100px;
    border-left: 10px solid #F5A524;
    .outer-wrapper{
        display: flex;
        align-items: center;
        width: 100%;
        height: 100%;
        background: #FFF6E9;
        .alert-icon{
            margin:15px;
        }
        .content{
            margin:5px;
            span{
                color: #7A5212;
            }
            .receive-conversation-button{
                span{
                    cursor: pointer;
                }
            }
        }
    }

    
`;


export default function ReceiveConversationNotifications(props: any) {

    const user = useSelector((state: any) => state.user);

    const windowReload = (e: any) => {
        simpleGTMDataLayer({
            csrId: user.userName,
            event: `Window-Reload-Click`,
            event_action: 'Button Click',
            event_category: window.location.pathname,
            event_label: `${user.fullName} clicked reload to receive existing conversations.`,
        });
        simpleGTMDataLayer({
            csrId: user.userName,
            event: `Window-Reload-Click-Snowplow`,
            event_action: 'Button Click',
            event_category: window.location.pathname + "/Snowplow",
            event_label: `${user.fullName} clicked reload to receive existing conversations.`,
        });
        window.location.reload();
    }

    return (
        <Template >
            <div className="outer-wrapper" style={{ display: "flex" }}>
                <div className="alert-icon">
                    <img src={Alerts_icon} alt="#" width={32} height={32} ></img>
                </div>
                <div className="content">
                    <SABox style={{ marginBottom: 10 }}>
                        <SAText text={`You have been transferred/copied into ${props.receivedConversationsCount} conversations`} />
                    </SABox>
                    <SABox onClick={windowReload} className="receive-conversation-button">
                        <SAText casing="uppercase" weight="bold" text="click to receive" />
                    </SABox>
                </div>
            </div>
        </Template>
    )
}
